import { api } from './api';
import { searchGetCourseMeta } from './helpers';


export function getUserCoursesAPI(username) {
  return new Promise((resolve) => {
    api.ibldmcourses.getUserCourses({ username }, (data) => {
      const courses = Array.isArray(data) ? data : [];
      resolve(courses);
    });
  });
}


export function getUserCoursesMetaData(course_id) {
  return new Promise((resolve) => {
    api.ibledxcourses.getCourseMeta({ course_id: course_id }, function(data) {
      resolve(data);
    });
  });

}

export function getUserCoursesSearchData(course_id) {
  return new Promise((resolve) => {
    searchGetCourseMeta(course_id, (metaData) => {
      if (metaData && !metaData.message && metaData.results && Array.isArray(metaData.results) && metaData.results.length > 0) {
        resolve(metaData.results[0]);
      } else {
        resolve(null);
      }
    });

  });

}











